import "./FormItemTextArea.scss";
import { Form, Input } from "antd";
import React from "react";

const { TextArea } = Input;

interface FormItemTextAreaProps {
  name: string;
  placeholder?: string;
  label: string;
  rules: { required: boolean; message?: string };
  defaultValue?: string;
  disabled?: boolean;
  maxLength?: number;
}

const FormItemTextArea: React.FC<FormItemTextAreaProps> = ({
  name,
  placeholder,
  rules,
  label,
  defaultValue,
  disabled,
  maxLength,
}) => {
  return (
    <Form.Item
      className={`form-item__input`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
    >
      <TextArea
        className={"input"}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        maxLength={maxLength}
        style={{ height: 120, resize: "none" }}
      />
    </Form.Item>
  );
};

export default FormItemTextArea;
